export function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
}

export function formatDateTime(timestamp) {
    // Output YYYY-mm-dd HH:MM UTC
    const date = new Date(timestamp);
    return (
        date.toISOString().split("T")[0] +
        " " +
        `${date.getUTCHours()}`.padStart(2, 0) +
        ":" +
        `${date.getUTCMinutes()}`.padStart(2, 0) +
        " UTC"
    );
}

export function genPaginationSequence(page, numOfPages, normalBtnSize) {
    const nextBtn = {
        type: "next",
        pageNum: page === numOfPages ? 0 : page + 1,
        isActive: false,
        isClickable: page !== numOfPages,
    };
    const prevBtn = {
        type: "prev",
        pageNum: page === 1 ? 0 : page - 1,
        isActive: false,
        isClickable: page !== 1,
    };
    const firstBtn = {
        type: "first",
        pageNum: 1,
        isActive: false,
        isClickable: page !== 1,
    };
    if (numOfPages <= normalBtnSize) {
        const restBtns = [];
        for (let i = 1; i <= numOfPages; i++) {
            restBtns.push({
                type: "number",
                pageNum: i,
                isActive: i === page,
                isClickable: true,
            });
        }
        return [prevBtn, ...restBtns, nextBtn];
    } else {
        const restBtns = new Array(normalBtnSize);
        let rangeStart;
        if (page === 1) {
            rangeStart = 1;
        } else {
            rangeStart = page - 1;
        }

        if (page > numOfPages - normalBtnSize + 1) {
            rangeStart = numOfPages - normalBtnSize + 1;
        }

        let rangeSize = normalBtnSize - 2;
        if (numOfPages - page > 3) {
            restBtns[normalBtnSize - 2] = {
                type: "delimiter",
                pageNum: 0,
                isActive: false,
                isClickable: false,
            };
            restBtns[normalBtnSize - 1] = {
                type: "number",
                pageNum: numOfPages,
                isActive: page === numOfPages,
                isClickable: true,
            };
        } else {
            rangeSize += 2;
        }

        for (let i = 0; i < rangeSize; i++) {
            restBtns[i] = {
                type: "number",
                pageNum: rangeStart + i,
                isActive: rangeStart + i === page,
                isClickable: true,
            };
        }
        if (rangeStart === 1) {
            return [prevBtn, ...restBtns, nextBtn];
        } else {
            return [firstBtn, ...restBtns, nextBtn];
        }
    }
}

export function utf8StrToHex(str) {
    const encoder = new TextEncoder();
    const data = encoder.encode(str);
    return [...data].map((c) => c.toString(16).padStart(2, 0)).join("");
}